import styled from "styled-components";

export const MobileCointainer = styled.div`
  margin: 20px 5px 5px 5px;
  border-top: 2px solid #000000;
  font-family: "neue-haas-grotesk-text";
`;

export const MobileWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid lightgray;
  flex-direction: column;
  padding: 8px 16px;
`;

export const RowWrapper = styled.div`
  display: flex;
  padding: 8px 0px;
`;

export const ColumnWrapper = styled.div`
  width: 50%;
  flex-direction: column;
  line-height: 20px;
  font-size: 14px;
  font-weight: ${({ fontWeight }) => fontWeight};
`;
